import React from 'react';

export default function ZombiePurgeModalDashedLine() {
	return (
		<svg width="158"
			height="1"
			viewBox="0 0 158 1"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<line x1="4.37114e-08"
				y1="0.5"
				x2="158"
				y2="0.500014"
				stroke="url(#paint0_linear_3460_60234)"
				strokeDasharray="2 2"/>
			<defs>
				<linearGradient id="paint0_linear_3460_60234"
					x1="79"
					y1="0.586545"
					x2="77.9389"
					y2="10.1489"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#B3FE00"/>
					<stop offset="1"
						stopColor="#00F644"/>
				</linearGradient>
			</defs>
		</svg>
    
	);
}
